import { useEffect, useState } from 'react';
import { SelectionInfo } from '../../word/types/wordTypes';
import { SelectionManager } from '../../features/rephrasing/SelectionManager';

export function useSelection(selectionManager: SelectionManager): SelectionInfo | null {
  const [selection, setSelection] = useState<SelectionInfo | null>(
    selectionManager.getSelection()
  );

  useEffect(() => {
    const unsubscribe = selectionManager.onSelectionChange((newSelection) => {
      setSelection(newSelection);
    });

    return unsubscribe;
  }, [selectionManager]);

  return selection;
}

